/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .fr-wrapper{height:200px;min-height:85px}[_nghost-%COMP%]   .ui-icon[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
